import type { DOMOutputSpec, Node as ProsemirrorNode, NodeSpec } from 'prosemirror-model';

import { NodeName } from '../../../schema/nodes';

export class ColumnNode implements NodeSpec {
  public static readonly nodeName = NodeName.Column;
  public static is(node: ProsemirrorNode) {
    return node.type.name === ColumnNode.nodeName;
  }

  public group = 'column';
  public content = 'block+';

  public parseDOM = [
    {
      tag: 'div',
      getAttrs: (dom: HTMLElement): null | false => {
        if (dom.classList.contains('pm-column')) return null;
        return false;
      },
    },
  ];

  public toDOM(): DOMOutputSpec {
    return [
      'div',
      {
        class: 'pm-column',
        style: 'display: flex; flex-direction: column; flex: 1; padding: 0 0.5em',
      },
      0,
    ];
  }
}
